import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import RealtimeState from '../../RealtimeState';
const CORE_POSTED_EVENT = 'Flarum\\Post\\Event\\Posted';
const CORE_RENAMED_EVENT = 'discussionRenamed';
const CORE_REVISED_EVENT = 'revisedEvent';
export default function () {
  extend(DiscussionPage.prototype, 'oninit', function () {
    this.websocketEventPosted = data => {
      var _this$stream, _this$discussion;
      // Capture BEFORE the payload (and the refetch below) updates postIds:
      // once new posts are in the store, viewingEnd()'s 1-post drift
      // tolerance can no longer tell "was at the end, several posts arrived
      // at once" apart from "viewing an interior window" — so a single
      // missed event would permanently disable live-append (#4717).
      const wasViewingEnd = !!((_this$stream = this.stream) != null && _this$stream.viewingEnd());
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === ((_this$discussion = this.discussion) == null ? void 0 : _this$discussion.id()) && this.stream) {
        const oldCount = this.discussion.commentCount();
        app.store.find('discussions', this.discussion.id()).then(() => {
          if (wasViewingEnd) {
            this.stream.syncEnd().then(() => m.redraw());
          } else {
            m.redraw();
          }
          if (!document.hasFocus()) {
            app.setTitleCount(Math.max(0, this.discussion.commentCount() - oldCount));
            $(window).one('focus', () => {
              app.setTitleCount(0);
            });
          }
        });
      }
    };
    this.websocketEventStreamUpdate = data => {
      var _this$stream2, _this$discussion2;
      // Same pre-payload capture as websocketEventPosted (#4717) — event
      // posts (sticky/lock/rename) move postIds too.
      const wasViewingEnd = !!((_this$stream2 = this.stream) != null && _this$stream2.viewingEnd());
      const discussion = app.store.pushPayload(data);
      if (discussion.id() === ((_this$discussion2 = this.discussion) == null ? void 0 : _this$discussion2.id()) && this.stream) {
        app.store.find('discussions', this.discussion.id()).then(() => {
          if (wasViewingEnd) {
            this.stream.syncEnd().then(() => m.redraw());
          } else {
            m.redraw();
          }
        });
      }
    };
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    // Bind handlers against the current channel objects. Extracted so it can
    // re-fire on reconnect — see flarum/framework#4597. On reconnect the
    // previous channel objects are discarded with the previous Pusher
    // instance, so re-binding against the new channels is non-duplicating.
    const bindHandlers = () => {
      var _app$websocket_channe, _app$websocket_channe2, _app$websocket_channe3, _app$websocket_channe4, _app$websocket_channe5, _app$websocket_channe6;
      (_app$websocket_channe = app.websocket_channels.public) == null || _app$websocket_channe.bind(CORE_POSTED_EVENT, this.websocketEventPosted.bind(this));
      (_app$websocket_channe2 = app.websocket_channels.user) == null || _app$websocket_channe2.bind(CORE_POSTED_EVENT, this.websocketEventPosted.bind(this));
      (_app$websocket_channe3 = app.websocket_channels.public) == null || _app$websocket_channe3.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate.bind(this));
      (_app$websocket_channe4 = app.websocket_channels.user) == null || _app$websocket_channe4.bind(CORE_RENAMED_EVENT, this.websocketEventStreamUpdate.bind(this));
      (_app$websocket_channe5 = app.websocket_channels.public) == null || _app$websocket_channe5.bind(CORE_REVISED_EVENT, this.websocketEventPosted.bind(this));
      (_app$websocket_channe6 = app.websocket_channels.user) == null || _app$websocket_channe6.bind(CORE_REVISED_EVENT, this.websocketEventPosted.bind(this));
      for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
        var _app$websocket_channe7, _app$websocket_channe8;
        (_app$websocket_channe7 = app.websocket_channels.public) == null || _app$websocket_channe7.bind(eventName, this.websocketEventStreamUpdate.bind(this));
        (_app$websocket_channe8 = app.websocket_channels.user) == null || _app$websocket_channe8.bind(eventName, this.websocketEventStreamUpdate.bind(this));
      }
    };
    bindHandlers();
    this._realtimeReconnectDisposer = RealtimeState.onChannelsReconnected(bindHandlers);
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    var _this$_realtimeReconn, _app$websocket_channe9, _app$websocket_channe0, _app$websocket_channe1, _app$websocket_channe10, _app$websocket_channe11, _app$websocket_channe12;
    (_this$_realtimeReconn = this._realtimeReconnectDisposer) == null || _this$_realtimeReconn.call(this);
    this._realtimeReconnectDisposer = null;
    (_app$websocket_channe9 = app.websocket_channels.public) == null || _app$websocket_channe9.unbind(CORE_POSTED_EVENT);
    (_app$websocket_channe0 = app.websocket_channels.user) == null || _app$websocket_channe0.unbind(CORE_POSTED_EVENT);
    (_app$websocket_channe1 = app.websocket_channels.public) == null || _app$websocket_channe1.unbind(CORE_RENAMED_EVENT);
    (_app$websocket_channe10 = app.websocket_channels.user) == null || _app$websocket_channe10.unbind(CORE_RENAMED_EVENT);
    (_app$websocket_channe11 = app.websocket_channels.public) == null || _app$websocket_channe11.unbind(CORE_REVISED_EVENT);
    (_app$websocket_channe12 = app.websocket_channels.user) == null || _app$websocket_channe12.unbind(CORE_REVISED_EVENT);
    for (const eventName of RealtimeState.getDiscussionStreamEventNames()) {
      var _app$websocket_channe13, _app$websocket_channe14;
      (_app$websocket_channe13 = app.websocket_channels.public) == null || _app$websocket_channe13.unbind(eventName);
      (_app$websocket_channe14 = app.websocket_channels.user) == null || _app$websocket_channe14.unbind(eventName);
    }
  });
}